'use client'

import { Box, Stack, Typography, useMediaQuery } from '@mui/material';
import dynamic from 'next/dynamic';
const Image = dynamic(() => import('@/components/common/image'), { ssr: false });
import * as yup from 'yup';
import { useFormik } from 'formik';
const Input = dynamic(() => import('@/components/common/input'), { ssr: false });
import { BUTTONTYPE } from '@/types/button-type';
import { VARIANT } from '@/types/variant';
import React from 'react';
const Button = dynamic(() => import('@/components/common/button'), { ssr: false });
import { useRouter } from 'next/navigation';
import { POST } from '@/api/post-requests';
const Title = dynamic(() => import('@/components/pages/program-details/title-container'), { ssr: false });
import { useNotifications } from '@toolpad/core/useNotifications';
import { useTranslations } from 'next-intl';


export default function Page() {
    const [loading, setLoading] = React.useState<boolean>(false);
    const notifications = useNotifications();
    const is_mobile = useMediaQuery('(max-width:1024px)');
    const t = useTranslations('forget_password');

    const validationSchema = yup.object({
        email: yup
            .string()
            .email()
            .required('Email is required')
    });
    const router = useRouter();

    const formik = useFormik({
        initialValues: {
            email: ""
        },
        validationSchema: validationSchema,
        onSubmit: async (values) => {
            setLoading(true);
            const response = await POST({
                url: 'v1/auth/forgot-password',
                body: {
                    email: values.email
                }
            });

            notifications.show(response.message, {
                severity: response.success ? 'success' : 'error',
                autoHideDuration: 3000,
            })
            if (response.success) {
                router.push(`/login/verification?email=${values.email}`)
            }
            setLoading(false);
        },
    });


    return <Box
        height={'100%'}
    >
        <Stack
            useFlexGap
            spacing={{ lg: 2, sm: 1, xs: 1, md: 1 }}
            marginBottom={2}
        >

            <Title title={t('title')} />

            <Typography
                marginTop={2}
                variant={is_mobile ? 'body2' : 'body1'}
                fontWeight={700}
            >
                {t('sub_title')}
            </Typography>

            <Input
                disabled={loading}
                start_icon={
                    <Image
                        alt={'mail icon'}
                        url={'/icons/Mail copy.svg'}
                        className="w-5"
                    />
                }
                label=''
                placeholder='Email'
                id='email'
                key='email'
                name='email'
                value={formik.values.email}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.email && Boolean(formik.errors.email)}
                helper_text={formik.touched.email && formik.errors.email}
            />


            <Stack
                marginTop={2}
                useFlexGap
                spacing={2}
            >

                <Button
                    loading={loading}
                    aria_label="submit button"
                    text={t('submit_btn')}
                    handleClick={() => { formik.handleSubmit() }}
                    type={BUTTONTYPE.SUBMIT}
                    key={'submit button'}
                    variant={VARIANT.CONTAINED}
                    className=' w-full'
                    borderRadius={is_mobile ? 8 : 12}
                />
                <Button
                    disabled={loading}
                    aria_label="cancel button"
                    text={t('cancel_btn')}
                    handleClick={() => { router.back() }}
                    type={BUTTONTYPE.BUTTON}
                    key={'cancel button'}
                    variant={VARIANT.OUTLINED}
                    className=' w-full'
                    borderRadius={is_mobile ? 8 : 12}
                />
            </Stack>

        </Stack>
    </Box>
};